module.exports = __webpack_public_path__ + "img/bg_back.43453247.png";